import React from 'react'
import { useLocation } from 'react-router-dom'
import { parse } from 'query-string'

export function FullscreenImage() {
  const location = useLocation()
  const { uri } = parse(location.search)

  // Validate URI to prevent XSS attacks
  const isValidUri = url => {
    if (!url || typeof url !== 'string') return false

    try {
      const parsed = new URL(url, window.location.origin)
      // Only allow http, https, and relative URLs
      return parsed.protocol === 'http:' || parsed.protocol === 'https:'
    } catch {
      return false
    }
  }

  const safeUri = isValidUri(uri) ? uri : ''

  if (!safeUri) {
    return <div>Invalid image URL</div>
  }

  return (
    <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={safeUri} alt="" />
  )
}
